export class CAReason {
  reasonCd: string;
  reasonDescription: string;
  comments: string;
}
